export const VARIABLES = {
    'VERSION': VERSION,
    'LOCAL_ENV': !!LOCAL_ENV,
    'SERVER_ENV': !!SERVER_ENV,
    'DEVELOP_ENVIRONMENT': !!DEVELOP_ENVIRONMENT,
    'STAGING_ENVIRONMENT': !!STAGING_ENVIRONMENT,
    'PRODUCTION_ENVIRONMENT': !!PRODUCTION_ENVIRONMENT,
};
console.info('ENVIRONMENT VARIABLES:', VARIABLES);
